import React, { useContext, useEffect, useState } from 'react';
import Icon from '../common/icons';
import AssessmentIcon from '../common/AssessmentIcon';
import Avatar from '../common/Avatar';
import { UserContext } from '../../context/UserContext';
import chatbotAvatar from '../../assets/Anna_Chat_Avatar.png';
import { useMyTests } from './useMyTests';
import { buildHomeCards, loadHomeData, showsPrograms } from './homeCardsData';
import './mainChat.css';

const tx = (lang, en, fil) => (lang === 'fil' ? fil : en);

const CardIcon = ({ card }) => {
  if (card.key === 'session') {
    return <Avatar name={card.counselor.name} photoUrl={card.counselor.photoUrl} size={44} className="hc-avatar" />;
  }
  if (card.type) {
    return (
      <span className={`hc-tile is-${card.type}`}>
        <AssessmentIcon type={card.type} size={22} />
      </span>
    );
  }
  return (
    <span className="hc-tile is-programs">
      <Icon name="bookmark" size={22} />
    </span>
  );
};

/** One card: what it is, then one big yellow button. */
export const HomeCard = ({ card, onAction, index = 0 }) => (
  <div className="hc-card" style={{ '--hc-i': index }}>
    <div className="hc-top">
      <CardIcon card={card} />
      <div className="hc-text">
        <span className="hc-kicker">{card.kicker}</span>
        <span className="hc-title">{card.title}</span>
        {card.sub && <span className="hc-sub">{card.sub}</span>}
      </div>
    </div>
    <button type="button" className="hc-btn" onClick={() => onAction(card.button)}>
      {card.button.label}
      <Icon name="arrow-right" size={18} />
    </button>
  </div>
);

/**
 * "Here's what's next for you." under Anna's greeting: a released result, the next session, a
 * test due soon and saved programs. Nothing shows until there is something to say.
 * `cards` replaces the loaded ones (the dev check page passes sample cards).
 */
const HomeCards = ({ lang = 'en', onAction, cards: givenCards = null }) => {
  const { user } = useContext(UserContext) || {};
  const programs = showsPrograms(user);
  const { tests } = useMyTests({ skip: Boolean(givenCards) });
  const [data, setData] = useState(null);

  useEffect(() => {
    if (givenCards) return undefined;
    let alive = true;
    loadHomeData({ programs })
      .then((loaded) => {
        if (alive) setData(loaded);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [programs, givenCards]);

  const cards = givenCards || buildHomeCards({ data, tests, userId: user?.id, programs, lang });
  if (!cards.length) return null;

  return (
    <div className="message bot hc-row">
      <div>
        <img className="chatbot-avatar message-avatar" src={chatbotAvatar} alt="" aria-hidden="true" />
      </div>
      <div className="hc-wrap">
        <div className="message-text bot hc-lead">{tx(lang, "Here's what's next for you.", 'Ito ang susunod para sa iyo.')}</div>
        <div className="hc-list" role="list">
          {cards.map((card, index) => (
            <div role="listitem" key={card.key}>
              <HomeCard card={card} onAction={onAction} index={index} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeCards;
